import React, { useMemo } from 'react';
import { string } from 'prop-types';
import { getContext } from '@fiverr-private/fiverr_context';
import { Container } from '@fiverr-private/layout_components';
import { Text, Heading } from '@fiverr-private/typography';
import { translationKeyWithLocale } from '../../../lib/translation/translationKeyWithLocale';
import { JoinButton } from './JoinButton';
import { VideoButton } from './VideoButton';

export const Header = ({ name, heading, tagling }) => {
    const { userId, locale, isTouch } = getContext();

    const translatedHeading = translationKeyWithLocale({
        k: 'tag_page_perseus.header.title',
        locale,
        params: { name },
    });

    const translatedTagling = translationKeyWithLocale({
        k: 'tag_page_perseus.header.subtitle',
        locale,
        params: { name },
    });

    const triggerButton = useMemo(() => (userId ? <VideoButton /> : <JoinButton />), [userId]);

    return (
        <Container
            paddingBottom={isTouch ? '4' : '10'}
            textAlign="center"
            marginY="0"
            marginX="auto"
            maxWidth="1240px"
            display="flex"
            direction="column"
            alignItems="center"
        >
            <Heading size={isTouch ? 'h_md' : 'h_xxl'} color="grey_1100">
                {heading || translatedHeading}
            </Heading>
            <Text color="grey_1000" size={isTouch ? 'b_sm' : 'b_md'} paddingTop="1" paddingBottom="4" maxWidth="650px">
                {tagling || translatedTagling}
            </Text>
            {triggerButton}
        </Container>
    );
};

Header.propTypes = {
    name: string,
    heading: string,
    tagling: string,
};
